import { useEffect, useState } from "react";
import LoaderHelper from "../../../../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../../../../context/AlertContext";
import AuthService from "../../../../../../api/AuthService";
import NotesHomePage from "../../../../../../entities/DashboardPage/AccountingModule/Customer/Notes/NotesHome";

const NotesHome = () => {
    const { showAlert } = useAlert();
    const [creditNoteData, setCreditNoteData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [total, setTotal] = useState(0);

  useEffect(() => {
    fetchInitialData();
  }, []);

  const fetchInitialData = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleGetAllCreditNotes();

      if (result?.success) {
        setCreditNoteData(result.data.creditNotes);
        setTotal(result.data.total);
        LoaderHelper.loaderStatus(false);
      } else {
        showAlert(result.message, "error");
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      showAlert("Failed to load data", "error");
      LoaderHelper.loaderStatus(false);
    }
  };


  const handleDelete = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleDeleteCreditNote(id);
      if (result?.success) {
        showAlert("Credit noted deleted successfully", "success")
        fetchInitialData();
        LoaderHelper.loaderStatus(false);
      } else {
        showAlert(result.message, "error")
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  return (
    <>
      <NotesHomePage 
        creditNoteData={creditNoteData}
        total={total}
        setTotal={setTotal}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        handleDelete={handleDelete}
      />
    </>
  );
};

export default NotesHome;
